import classNames from '@sindresorhus/class-names';
import {useEnvConfig} from '@web-catalog/env';
import {useCallback, useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

import {YandexBannerAd} from './YandexBannerAd';
import styles from './YandexFloorAdBanner.module.scss';

export const YandexFloorAdBanner = () => {
  const {YANDEX_ADS_FLOOR_AD_BANNER_ID} = useEnvConfig();
  const rootRef = useRef(document.getElementById('root'));
  const [scrolled, setScrolled] = useState(false);
  const [failed, setFailed] = useState(false);

  const blockId = YANDEX_ADS_FLOOR_AD_BANNER_ID;

  useEffect(() => {
    const root = rootRef.current;
    if (root) {
      const scrollOffset = document.documentElement.scrollTop;
      root.classList.add(styles.rootContainer);
      root.scrollTop = scrollOffset;
    }
    // on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const root = rootRef.current;
    if (scrolled || !root) {
      return;
    }

    const onScrolled = () => setScrolled(true);

    if (root.scrollTop > 0) {
      // уже поскроллились - можно и показать рекламу
      onScrolled();
      return;
    }

    // на мобильном сафари scrollend не поддерживается, поэтому scroll + таймауты
    let timeoutHandle: NodeJS.Timeout | null = null;

    const listener = () => {
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      timeoutHandle = setTimeout(onScrolled, 50);
    };
    root.addEventListener('scroll', listener);

    return () => {
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      root.removeEventListener('scroll', listener);
    };
  }, [blockId, scrolled]);

  const shouldShowAd = scrolled && !failed;

  useEffect(() => {
    if (shouldShowAd) {
      rootRef.current?.classList.add(styles.adShown);
    } else {
      rootRef.current?.classList.remove(styles.adShown);
    }
  }, [shouldShowAd, blockId]);

  const onErrorOrNoAd = useCallback(() => setFailed(true), []);

  const onRender = useCallback(() => setFailed(false), []);

  if (!shouldShowAd) {
    return null;
  }

  return (
    <>
      {createPortal(
        <div
          className={classNames(
            styles.adContainer,
            shouldShowAd && styles.adShown,
          )}
        >
          <YandexBannerAd
            bannerContainerClassName={styles.ad}
            blockId={YANDEX_ADS_FLOOR_AD_BANNER_ID}
            adType="floor_ad_banner"
            additionalId="floor-ad"
            onRender={onRender}
            onError={onErrorOrNoAd}
            onNoAds={onErrorOrNoAd}
          />
        </div>,
        document.body,
      )}
    </>
  );
};
